import { Box, Typography } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  changeStatus,
  deleteUser,
  getAdmins,
  loginAdminToUser,
} from "../../api/admins";
import {
  changeStatusGroupLeader,
  getAllGroups,
  getGroupAdminInfo,
  getGroupLeaderInfo,
  getGroupsUsers,
  removeFromGroup,
  signInGroupUser,
} from "../../api/group";
import { getToken, setToken, setTokenUser } from "../../api/token";
import AccessibilityIcon from "../../assets/SVG/accessibilityIcon";
import CloseIcon from "../../assets/SVG/closeIcon";
import DeleteIcon from "../../assets/SVG/deleteIcon";
import ExcelIcon from "../../assets/SVG/excelIcon";
import EyeIcon from "../../assets/SVG/eyeIcon";
import PrintIcon from "../../assets/SVG/printIcon";
import ViewProfile from "../profile/viewProfile";

export default function SelectiosnFuncTable({
  count,
  data,
  setRowData,
  setData,
  onBtExport,
  selected,
  setDataMyInfo,
  setOpenProfilePop,
  setGroupInfo,
}) {
  // console.log(data[0].data.groupName);
  // console.log(data);
  const navigate = useNavigate();
  return (
    <Box sx={{ display: "flex", justifyContent: "center" }}>
      <Box
        sx={{ boxShadow: "0px 4px 15px 0px rgba(0, 0, 0, 0.25)" }}
        bgcolor="#9091A6"
        width="65%"
        height="60px"
        borderRadius="30px"
        position={"fixed"}
        bottom="20px"
        display="flex"
        justifyContent={"space-between"}
        alignItems="center"
      >
        <Box display="flex" alignItems="center" mr="20px" gap="20px">
          <CloseIcon size="1.8" color="white" />
          <Typography
            fontFamily={"Shabnam"}
            color="white"
            fontSize="18px"
          >{`${count} مورد انتخاب شده`}</Typography>
        </Box>
        <Box display="flex">
          {count === 1 && (
            <>
              <Box
                bgcolor="#676995"
                width="190px"
                height="40px"
                borderRadius="10px"
                display="flex"
                alignItems={"center"}
                justifyContent={"center"}
                color="white"
                marginInlineEnd={"20px"}
                sx={{ cursor: "pointer" }}
                gap="10px"
                onClick={() => {
                  if (data?.length > 0) {
                    if (selected === 4) {
                      signInGroupUser({
                        nid: data[0]?.data.nid,
                      })
                        .then((y) => {
                          setTokenUser(getToken());
                          setToken(y);
                          // setTimeout(() => {
                          navigate("/");
                          window.location.reload();
                          // }, 3000);
                        })
                        .catch(() => {});
                    } else {
                      loginAdminToUser({
                        nid: data[0]?.data.nid,
                      })
                        .then((y) => {
                          setTokenUser(getToken());
                          setToken(y);
                          // setTimeout(() => {
                          navigate("/");
                          window.location.reload();
                          // }, 3000);
                        })
                        .catch(() => {});
                    }
                  }
                }}
              >
                <EyeIcon size="1.2" color="white" />
                {selected !== 2 ? "مشاهده صفحه جهادگر" : "مشاهده صفحه گروه"}
              </Box>
              <Box
                bgcolor={
                  data[0]?.data?.status === "PENDING" ? "#682C54" : "#F05542"
                }
                width="150px"
                height="40px"
                borderRadius="10px"
                display="flex"
                alignItems={"center"}
                justifyContent={"center"}
                color="white"
                marginInlineEnd={"20px"}
                sx={{ cursor: "pointer" }}
                gap="10px"
                onClick={() => {
                  if (selected === 1) {
                    changeStatus(
                      data[0].data.id,
                      data[0].data.status === "PENDING" ? "ACTIVE" : "PENDING"
                    )
                      .then(() => {
                        getAdmins()
                          .then((x) => {
                            setRowData(x);
                            setData([]);
                          })
                          .catch((z) => console.log(z));
                      })
                      .catch(() => {});
                  }
                  if (selected === 2) {
                    changeStatus(
                      data[0].data.id,
                      data[0].data.status === "pending" ||
                        data[0].data.status === "PENDING"
                        ? "ACTIVE"
                        : "PENDING"
                    )
                      .then(() => {
                        getAdmins(`?justGroupRequests=true`)
                          .then((x) => {
                            setRowData(x);
                            setData([]);
                          })
                          .catch((z) => console.log(z));
                      })
                      .catch(() => {});
                  }
                  if (selected === 3) {
                    changeStatus(
                      data[0].data.id,
                      data[0].data.status === "pending" ||
                        data[0].data.status === "PENDING"
                        ? "ACTIVE"
                        : "PENDING"
                    )
                      .then(() => {
                        getAdmins(`?groupName=${data[0].data.groupName}`)
                          .then((x) => {
                            setRowData(x);
                            setData([]);
                            // setLoading(false);
                          })
                          .catch((z) => console.log(z));
                      })
                      .catch(() => {});
                  }
                  if (selected === 4) {
                    changeStatusGroupLeader(
                      data[0].data.id,
                      data[0].data.status === "pending" ||
                        data[0].data.status === "PENDING"
                        ? "ACTIVE"
                        : "PENDING"
                    )
                      .then(() => {
                        getGroupsUsers()
                          .then((x) => {
                            setRowData(x);
                            setData([]);
                            // setLoading(false);
                          })
                          .catch((z) => console.log(z));
                      })
                      .catch(() => {});
                  }
                }}
              >
                <AccessibilityIcon size="1" color="white" />
                {selected === 1
                  ? data[0]?.data?.status === "PENDING"
                    ? "اجازه دسترسی"
                    : "لغو دسترسی"
                  : data[0]?.data?.status === "PENDING" ||
                    data[0]?.data?.status === "pending"
                  ? "اجازه دسترسی"
                  : "لغو دسترسی"}
              </Box>
            </>
          )}
          {count >= 2 && (
            <>
              <Box
                bgcolor="#686A97"
                width="110px"
                height="40px"
                borderRadius="10px"
                display="flex"
                alignItems={"center"}
                justifyContent={"center"}
                color="white"
                marginInlineEnd={"20px"}
                sx={{ cursor: "pointer" }}
                gap="10px"
              >
                <PrintIcon />
                چاپ
              </Box>
              <Box
                bgcolor="#686A97"
                width="150px"
                height="40px"
                borderRadius="10px"
                display="flex"
                alignItems={"center"}
                justifyContent={"center"}
                color="white"
                marginInlineEnd={"20px"}
                sx={{ cursor: "pointer" }}
                gap="10px"
                onClick={onBtExport}
              >
                <ExcelIcon />
                خروجی اکسل
              </Box>
            </>
          )}
          <Box
            bgcolor="#E24B4B"
            width="150px"
            height="40px"
            borderRadius="10px"
            display="flex"
            alignItems={"center"}
            justifyContent={"center"}
            color="white"
            marginInlineEnd={"20px"}
            sx={{ cursor: "pointer" }}
            onClick={() => {
              data.map((x) => {
                if (selected === 4) {
                  removeFromGroup(x.data.id)
                    .then(() => {
                      getGroupsUsers()
                        .then((x) => {
                          setRowData(x);
                          setData([]);
                        })
                        .catch((z) => console.log(z));
                    })
                    .catch(() => {});
                } else {
                  deleteUser(x.data.id)
                    .then(() => {
                      getAdmins()
                        .then((x) => {
                          setRowData(x);
                          setData([]);
                        })
                        .catch((z) => console.log(z));
                    })
                    .catch(() => {});
                }
              });
            }}
          >
            <DeleteIcon color="white" />
            {selected !== 2 ? "حذف جهادگران" : "حذف گروه"}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
